// Route selection must not load the authenticated API dependency graph.
export const hasOAuthHashSession = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;

  if (!hash) {
    return false;
  }

  return Boolean(new URLSearchParams(hash).get('token')?.trim());
};
